// TICKET-01346: text template pickers must list templates alphabetically.
// The desktop journal picker sorts by title, but the quick "save as template"
// button stores templates without a title (89% of all templates have none),
// so the title sort has nothing to work on and the list ends up newest-first.
// Sort by title when set, otherwise by the template body (its first line acts
// as the de-facto name), using the Norwegian locale. Always sort a copy —
// the caller may pass a shared MobX store array.
export function templateSortKey(template = {}) {
    const title = typeof template.title === 'string' ? template.title.trim() : '';
    if (title) {
        return title;
    }
    return typeof template.body === 'string' ? template.body.trim() : '';
}

export function compareTextTemplates(a = {}, b = {}) {
    return templateSortKey(a).localeCompare(templateSortKey(b), 'nb', { sensitivity: 'base' });
}

export function sortTextTemplates(templates = []) {
    return [...templates].sort(compareTextTemplates);
}

export default sortTextTemplates;
